import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Bell } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Lead notifications (new high-score AI leads) — clean bell with unread badge.
export default function NotificationsBell() {
  const [data, setData] = useState({ unread: 0, items: [] });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const fetchNotifs = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/live-chat/lead-notifications?limit=20`);
      const d = await res.json();
      if (d.success) setData({ unread: d.unread || 0, items: d.notifications || [] });
    } catch (e) { console.error('notifs', e); }
  }, []);

  useEffect(() => {
    fetchNotifs();
    const t = setInterval(fetchNotifs, 30000);
    return () => clearInterval(t);
  }, [fetchNotifs]);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const markRead = async () => {
    try {
      await fetch(`${API_URL}/api/live-chat/lead-notifications/mark-read`, { method: 'POST' });
      setData(prev => ({ ...prev, unread: 0 }));
    } catch (e) { console.error(e); }
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => { setOpen(o => !o); if (!open) markRead(); }} data-testid="crm-notifications-bell"
        className="relative h-9 w-9 inline-flex items-center justify-center rounded-md border border-zinc-200 text-zinc-600 hover:bg-zinc-50">
        <Bell className="w-4 h-4" strokeWidth={2} />
        {data.unread > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 bg-rose-600 text-white text-[10px] font-semibold rounded-full flex items-center justify-center tabular-nums">{data.unread}</span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 top-11 w-80 bg-white rounded-xl border border-zinc-200 shadow-lg z-50 max-h-96 overflow-y-auto" data-testid="crm-notifications-panel">
          <div className="px-4 py-3 border-b border-zinc-100">
            <p className="text-sm font-medium text-zinc-900">Lead Notifications</p>
          </div>
          {data.items.length === 0 ? (
            <p className="p-6 text-sm text-zinc-400 text-center">कोई notification नहीं</p>
          ) : data.items.map((n, i) => (
            <div key={i} className={`px-4 py-3 border-b border-zinc-50 ${!n.read ? 'bg-zinc-50' : ''}`}>
              <div className="flex items-center justify-between mb-0.5">
                <span className="text-xs font-semibold text-zinc-900 tabular-nums">Score {n.lead_score}</span>
                <span className="text-[11px] text-zinc-400">{n.status}</span>
              </div>
              <p className="text-sm text-zinc-700">{n.lead_profile?.school_name || 'Unknown'}</p>
              <p className="text-xs text-zinc-500">{n.lead_profile?.role || ''}{n.lead_profile?.student_count ? ` · ${n.lead_profile.student_count} students` : ''}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
